import { Reveal } from "@/components/bits";
import PreorderCta from "@/components/store/PreorderCta";
import { POGO_LIFESTYLE } from "@/config/pogoConfig";

// Final close — full pink band mini-hero directly above the footer.
export default function FinalClose() {
  return (
    <section data-testid="final-close" className="bg-[#FF6BAA]">
      <div className="px-4 py-12 sm:py-16 max-w-2xl mx-auto w-full">
        <Reveal>
          <img
            data-testid="final-close-image"
            src={POGO_LIFESTYLE[0].src}
            alt={POGO_LIFESTYLE[0].alt}
            className="w-full aspect-[4/5] object-cover rounded-3xl border-2 border-ink shadow-[4px_4px_0px_#111111] select-none"
            loading="lazy"
            draggable="false"
          />
          <h2 className="mt-7 font-display uppercase leading-[0.95] text-[10.5vw] sm:text-5xl">
            Ready to <span className="text-ivory">upgrade</span> your shift?
          </h2>
          <p className="mt-3 text-base sm:text-lg max-w-md font-medium">
            Pick your colour, pick your size, reserve your pair from the first
            production run.
          </p>
          <PreorderCta
            testId="final-close-cta"
            origin="landing_final"
            label="Preorder your POSSOS"
            variant="ink"
            className="mt-6 w-full sm:max-w-sm !shadow-[3px_3px_0px_rgba(247,243,235,0.9)]"
          />
        </Reveal>
      </div>
    </section>
  );
}
